import { LogsBase } from "~/areas/configuration/components/Diagnostics/Logs/LogsBase";
export class AutoDeployLogsPage extends LogsBase {
    constructor(props: {}) {
        super("ProcessAutoDeployments", "Auto Deploy Logs", props);
    }
}
